import React, { useEffect, useRef } from 'react';
import { useAuth } from './AuthContext';
import { getApiBase } from '../api/config';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export function GoogleLoginButton() {
  const buttonRef = useRef(null);
  const { login } = useAuth();

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID || !window.google) return;

    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: async (response) => {
        try {
          const res = await fetch(`${getApiBase()}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id_token: response.credential }),
          });
          if (!res.ok) throw new Error('Login failed');
          const data = await res.json();
          login(data.token, data.user);
        } catch (err) {
          console.error('Login error:', err);
        }
      },
    });

    window.google.accounts.id.renderButton(buttonRef.current, {
      theme: 'outline',
      size: 'large',
      type: 'standard',
    });
  }, [login]);

  if (!GOOGLE_CLIENT_ID) return null;

  return <div ref={buttonRef} />;
}
